import styled, { css, keyframes } from "styled-components";
import {
    type DisplayProps,
    type WidthProps,
    type FlexboxProps,
    type BorderProps,
    display,
    width,
    flexbox,
    compose,
    border,
} from "styled-system";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Button from "../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as ContainerStyles from "../../../../../common-deprecated/styles/v2/toyota/globals/Container";

const overFlowAuto = keyframes`
  0% {
      overflow: initial;
  }
  99% {
      overflow: initial;
  }
  100% {
      overflow: auto;
  }
`;

export const Container = styled(ContainerStyles.default)<{ isWide?: boolean }>`
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    /* Shame... got overruled by external styles not selector */
    padding: 0 !important;
    @media (min-width: 1200px) {
        max-width: ${({ isWide }) => (isWide ? 980 : 780)}px;
    }
`;

export const Wrapper = styled.section<{ expanded?: boolean; isPdf?: boolean }>`
    display: flex;
    position: fixed;
    top: 100%;
    left: 0;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    background: ${theme.colors.primaryWhite};
    box-shadow: 0 -4px 11px 0 rgba(0, 0, 0, 0.3);
    transform: translateY(${({ expanded }) => (expanded ? "-100%" : 0)});
    transition: transform 0.5s;
    overflow: initial;
    will-change: transform;
    z-index: ${theme.zIndex.popover};
    -webkit-overflow-scrolling: touch;

    ${({ expanded }) =>
        expanded &&
        css`
            animation: ${overFlowAuto} 0.5s linear;
            overflow-y: hidden;
            overflow-x: hidden;
        `};

    ${({ isPdf }) =>
        isPdf &&
        css`
            display: block;
            position: relative;
            top: auto;
            left: auto;
            width: auto;
            margin: 0;
            padding-bottom: 50px;
            box-shadow: none;
            transform: none;
            overflow: visible;
        `};

    html[dir="rtl"] & {
        left: auto;
        right: 0;
        ${({ isPdf }) =>
            isPdf &&
            css`
                left: auto;
                right: auto;
            `}
    }
`;

export const PdfSection = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin: ${theme.space[5]}px 0;

    /* Override CSS from foundation team */
    ${Button.Cta} {
        margin: 0 !important;
        padding-right: 0 !important;
        background: none !important;
    }

    html[dir="rtl"] & {
        ${Button.Cta} {
            padding-left: 0 !important;
        }
    }
`;

export const Row = styled.div`
    padding: 0;
    @media ${getBreakpoint("only", "md")} {
        padding: 0 ${theme.space[1]}px;
    }
`;

const styles = compose(display, width, flexbox, border);
export const Col = styled.div<DisplayProps & WidthProps & FlexboxProps & BorderProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${theme.space[3]}px;
    ${styles};
    @media ${getBreakpoint("up", "md")} {
        max-width: 245px;
    }
`;

export const Body = styled.div<{ isPdf?: boolean }>`
    width: 100%;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.primaryWhite};
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;

    @media ${getBreakpoint("only", "md")} {
        margin-left: auto;
        margin-right: auto;
    }

    @media all and (-ms-high-contrast: active) and (-ms-high-contrast: none) {
        /**
            Fix specific for IE11, to add some spacing above the body, else the car images are hidden after the compare header :(
        */
        position: relative;
        top: 100px;
    }

    ${({ isPdf }) =>
        isPdf &&
        css`
            position: static !important;
            top: 0 !important;
            margin-top: 30px !important;
            overflow: visible !important;
        `};
`;

export const CompareItems = styled.div`
    display: flex;
    width: 100%;
    max-width: 100%;
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.space[2]}px;
    padding: ${theme.space[3]}px 0;

    button span,
    a span {
        white-space: normal;
        overflow: hidden;
        /* stylelint-disable */
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        /* stylelint-enable */
    }
`;
